import {
	borderRadius,
	  flexbox,
	  fontbox,
	  fullHeight,
	  fullWidth,
	  imageBox,
	  marginAuto,
	  paddingX,
	  paddingXY,
	  paddingY,
	  theme,
  } from "../../emotion/utils";
  
  export const css = {
	datePicker: {
		// width:`100%`,
	},
		container: {
			height:'100px',
			...flexbox("row", "center", "space-between", 20),
			...marginAuto(),
			...paddingY(20),
			maxWidth: "90%",
	
			"@media screen and (min-width: 1200px)": {
				...paddingX(32),
				maxWidth: "92%",
			},
	
			img: {
				...imageBox("auto", 86, "100%"),
	
				"@media screen and (min-width: 768px)": {
					...imageBox("auto", 142, "100%"),
				},
			},
		},
  
//   fieldset: {
//   width: '100%',
//   marginBottom: 10,
//   padding: 10,
//   border: '1px solid #ddd',
//   borderRadius: 5
// }
  };
  